const results = [
  'более самостоятельные сотрудники;',
  'повышение ответственности команды;',
  'меньше зависимости от постоянного контроля руководителя;',
  'более понятная коммуникация задач и ожиданий;',
  'более качественная обратная связь сотрудникам;',
  'развитие инициативы и предложений от команды;',
  'более конструктивное решение конфликтов;',
  'повышение управленческой самостоятельности руководителей;',
  'более эффективное принятие решений;',
  'развитие будущих руководителей внутри компании;',
  'единый подход к управлению командой.',
];

export default function CompanyResults() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Что получает компания
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Возможные результаты развития лидерских компетенций руководителей
        </p>

        <div className="max-w-4xl mx-auto">
          <div className="grid sm:grid-cols-2 gap-3">
            {results.map((r, i) => (
              <div key={i} className="flex items-start gap-2.5 bg-white rounded-xl border border-gray-200 p-4">
                <i className="ri-check-line text-teal-600 mt-0.5 flex-shrink-0"></i>
                <span className="text-sm text-gray-700">{r}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}